export const MAX_NUMBER_OF_WIDGETS_FOR_AI_PROCESS = 70;

export const MIN_NUMBER_OF_SYMBOLS = 5;

export const SNACKBAR_TIMEOUT = 7000;

export const TEXT_WIDGET_LEFT_MARGIN = 30;

export const TEXT_WIDGET_TOP_MARGIN = 50;
